import { useState } from 'react';
import { Outlet, useLocation } from 'react-router';
import { SideNav, SettingsModal } from '../components';
import GuideProvider from '../components/reguide/GuideProvider';
import { GUIDE_STEPS, useReguideTarget } from '../stores/ReguideContext';
import HeaderSearchContext from '../stores/HeaderSearchContext';
import DashboardHeader from '../components/dashboard/DashboardHeader';

const DashboardLayoutContent = () => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [searchSlot, setSearchSlot] = useState<HTMLDivElement | null>(null);
  const desktopNavigationTarget = useReguideTarget<HTMLDivElement>(
    GUIDE_STEPS.NAVIGATION_DESKTOP
  );
  const mobileNavigationTarget = useReguideTarget<HTMLButtonElement>(
    GUIDE_STEPS.NAVIGATION_MOBILE
  );

  const toggleCollapse = () => setIsCollapsed((prev) => !prev);

  return (
    <HeaderSearchContext.Provider value={searchSlot}>
      <div className="flex h-dvh overflow-hidden bg-base-100 text-base-content">
        <aside
          className={`${isCollapsed ? 'w-20 p-2' : 'w-60 lg:w-72 p-4 lg:px-7'} hidden md:flex
        h-full shrink-0 bg-base-200 flex-col justify-between
        transition-all duration-150 ease-linear
        border-r border-[var(--light-gray)]`}
        >
          <SideNav
            isCollapsed={isCollapsed}
            toggleCollapse={toggleCollapse}
            navigationTargetRef={desktopNavigationTarget}
          />
        </aside>
        <div className="flex min-h-0 min-w-0 flex-1 flex-col">
          <DashboardHeader
            searchSlotRef={setSearchSlot}
            navigationTargetRef={mobileNavigationTarget}
          />
          <main className="min-h-0 min-w-0 flex-1 overflow-y-auto overflow-x-hidden">
            <Outlet />
          </main>
        </div>
      </div>
      <SettingsModal modalId="settings-modal" />
    </HeaderSearchContext.Provider>
  );
};

const DashboardLayout = () => {
  const { pathname } = useLocation();
  const guideEnabled = [
    '/dashboard',
    '/dashboard/library',
    '/dashboard/favorites',
  ].includes(pathname);

  return (
    <GuideProvider enabled={guideEnabled}>
      <DashboardLayoutContent />
    </GuideProvider>
  );
};

export default DashboardLayout;
